module.exports = __webpack_public_path__ + "img/a-active.04213744.png";